// extracted by mini-css-extract-plugin
module.exports = {"model":"PasswordChange_model__1rEv2","content":"PasswordChange_content__6w3tz"};